import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: number;
  title: string;
  excerpt: string;
  category: string;
  author: string;
  date: string;
  readTime: string;
  image: string;
  categoryName?: string;
  categorySlug?: string;
}

export default function ArticleCard({
  id,
  title,
  excerpt,
  author,
  date,
  readTime,
  image,
  categoryName,
  categorySlug,
}: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer">
      <Link to={`/article/${id}`} className="block">
        <div className="relative w-full h-48 overflow-hidden">
          <img
            src={image}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            title={title}
          />
        </div>
      </Link>
      <div className="p-5">
        {categoryName && categorySlug && (
          <Link
            to={`/category/${categorySlug}`}
            className="inline-block text-xs font-medium text-primary-600 bg-primary-100/70 px-2.5 py-1 rounded-full mb-3 hover:bg-primary-200 transition-colors cursor-pointer"
          >
            {categoryName}
          </Link>
        )}
        <Link to={`/article/${id}`} className="block">
          <h3 className="font-heading text-base font-semibold text-foreground-900 leading-snug mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
            {title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-2">
          {excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <div className="flex items-center gap-3">
            <span>{author}</span>
            <span className="text-foreground-400">·</span>
            <span>{date}</span>
          </div>
          <span>{readTime}</span>
        </div>
      </div>
    </article>
  );
}